import React from 'react';
import IndexedFormRow from '../IndexedFormRow';
import CollapseContainer from "../../CollapseContainer/CollapseContainer";
import { Field } from "redux-form";
import { renderField } from "../../../utils/formUtils";
import PrivacyRow from "../PrivacyRow/PrivacyRow";
import { Translate } from "react-localize-redux";

const defaultWebAddress = {
  address:"",
  privacy: "PU",
  category: "Home",
  order_index: 0,
};

const WebAddressFormPanel = () => (
  <CollapseContainer title={<Translate id="Websites" />} startCollapsed={true}>
    <IndexedFormRow
      defaultEntry={defaultWebAddress}
      privacyRow={<PrivacyRow rowOffset={8}/>}
      modelArrayName="websites"
      showCategory={false}
      dataComponent={member => (
        <Field
          name={`${member}.address`}
          type="text"
          hideLabel={true}
          component={renderField}
          label="address"
        />
      )}
    />
  </CollapseContainer>
);

export default WebAddressFormPanel;


// WEBPACK FOOTER //
// ./src/components/forms/WebAddressFormPanel/WebAddressFormPanel.jsx